export { CollectionCarousel } from './collection-carousel';
